import AppTextField from "@/components/AppTextField";
import NationChooser from "@/components/NationChooser";
import SendCodeButton from "@/components/SendCodeButton";
import AppLoadingButton from "@/components/mui/LoadingButton";
import API from "@/constant/API";
import { VerifyAction } from "@/constant/VerifyConstant";
import { getTaskId, getUserInfo } from "@/redux/slices/user";
import { dispatch } from "@/redux/store";
import axiosInstance from "@/utils/axios";
import { Box, InputAdornment } from "@mui/material";
import { t } from "i18next";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "@/pages/security/css/index.module.less";
import {useTranslation} from "react-i18next";
import {enqueueSnackbar} from "notistack";
import SimpleHeader from "../components/Headers/SimpleHeader";
import NationSelect from "@/components/NationSelect";

function SecurityMobileUpdate() {
  const navigate = useNavigate();
  const { t } = useTranslation();
  const { user } = useSelector(state => state.user);
  const [loading, setLoading] = useState(false);

  const [mobile, setMobile] = useState('');
  const [code, setCode] = useState('');
  const [nationRecord, setNationRecord] = useState(null);
  const [nationCode, setNationCode] = useState(null);

  const handleSubmit = async (evt) => {
    evt.preventDefault();

    if(!mobile){
      enqueueSnackbar(t('mobile_is_not_empty'), { variant: 'error' })
      return
    }
    if(!code){
      enqueueSnackbar(t('code_is_not_empty'), { variant: 'error' })
      return
    }
    const params = {
      mobile: mobile,
      nationCode: nationCode,
      code: code,
    };
    try {
      setLoading(true);
      const tokenModel = await axiosInstance.post(API.MOBILE_UPDATE_VERIFY, params);
      params['sign'] = tokenModel?.sign;
      params['taskId'] = getTaskId();
      await axiosInstance.post(API.MOBILE_UPDATE, params);
      // TODO: toast 提示用户修改mobile成功
      enqueueSnackbar(t('successful'), { variant: 'success' })
      dispatch(getUserInfo());
      navigate(-1);
    } catch (e) {
      // console.log("提交失败",e);
      // enqueueSnackbar(t('fail'), { variant: 'error' })
    } finally {
      setLoading(false);
    }
  }

  const onNationCodeChange = function(val) {
    setNationRecord(val);
    setNationCode(val.areaCode);
  };

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}>
        <div className={classes["security-title"]}>{t('mobile_update')}</div>
        <div className={classes["security-subtitle"]}>{t('mobile_subtitle')}</div>
      </Box>

      <form autoComplete="off" onSubmit={handleSubmit}>
        <Box className={classes["column-gap-wrap"]}>
          <AppTextField
            label={t('mobile')}
            placeholder={t('mobile')}
            onChange={(e) => setMobile(e.target.value.trim())}
            required
            value={mobile}
            fullWidth
            clearable
            onClear={() => setMobile('')}
            InputProps={{
              startAdornment:
                <InputAdornment position="start">
                  <NationSelect isBindMobile variant='borderless' isCompact={true} selected={nationRecord} onSelect={onNationCodeChange} />
                </InputAdornment>
            }}
          />
          <AppTextField
            label={t('code')}
            placeholder={t('code')}
            onChange={(e) => setCode(e.target.value.trim())}
            required
            value={code}
            fullWidth
            clearable
            onClear={() => setCode('')}
            InputProps={{
              endAdornment: (
                <InputAdornment position="end">
                  <SendCodeButton
                    btnText={t('send_code')}
                    action={VerifyAction.UPDATE_SMS}
                    enable={true}
                    type={0}
                    params={{
                      mobile: mobile,
                      nationCode: nationCode,
                    }}
                    onError={(error)=>{
                    }}
                  />
                </InputAdornment>
              ),
            }}
          />
        </Box>
      </form>

      <Box className={classes["fixed-button"]}>
        <AppLoadingButton
          fullWidth
          loading={loading}
          variant="contained"
          color="primary"
          size="large"
          type="submit"
          onClick={handleSubmit}
        >
          {t('confirm')}
        </AppLoadingButton>
      </Box>
    </Box>
  </>);
}

export default SecurityMobileUpdate;
